import appConfig from 'src/utils/appConfig';
import redirectionEventsHandler  from 'src/utils/events/redirectionEventsHandler';
import { getReturnToURLFromParams } from 'src/router/queryString';

const dashboardUrl = `${appConfig.getMyConfig().myBaseUrl}/dashboard`;
const returnToURLQueryParams = getReturnToURLFromParams();
const redirectUrl = returnToURLQueryParams || dashboardUrl;

export default () => {
  redirectionEventsHandler(location.href, redirectUrl);
  location.replace(redirectUrl);
};
